module.exports = __webpack_public_path__ + "img/rocket-thruster.0fbdf862.svg";